import { Injectable } from '@angular/core';
import { PreOnBoarding } from '../pages/account-request-and-pod-submission/company-or-individual/company-or-individual.model';

@Injectable({
  providedIn: 'root',
})
export class PODDataService {
  termsAndConditionsId: any;
  creditorContactNumber: string = "";
  creditorCountryCode: string = "";
  isDraftLoaded: boolean= false;
  constructor() { }
  private _items: CompanyItem[] = [];
  preOnBoarding: PreOnBoarding = new PreOnBoarding();
  private items: any[] = [];
  files: CreditorClaim = new CreditorClaim();
  setIsDraftLoaded(value: boolean) {
    this.isDraftLoaded = value;
  }
  getIsDraftLoaded() {
    return this.isDraftLoaded;
  }
  clearCreditorContactDeatils() {
    this.creditorContactNumber = "";
    this.creditorCountryCode = "";
  }
  setContactNumber(number: string) {
    this.creditorContactNumber = number;
  }
  getContactNumber() {
    return this.creditorContactNumber;
  }
  setCountryCode(code: string) {
    this.creditorCountryCode = code;
  }
  getCountryCode() {
    return this.creditorCountryCode;
  }
  setTermsAndConditionsId(id:any){
    this.termsAndConditionsId=id;
  }
  getTermsAndConditionsId(){
    return this.termsAndConditionsId;
  }
  addCompanyItem(item: CompanyItem) {
    this._items.push(item);
  }

  getCompanyItems(): CompanyItem[] {
    return this._items;
  }

  addClaims(item: PreOnBoarding) {
    this.preOnBoarding=item;
  }
  getClaims(): PreOnBoarding {
    return this.preOnBoarding;
  }
  emptyClaims() {
    this.preOnBoarding = new PreOnBoarding();
  }
  getFiles(index: any) {
    return this.files[index];
  }

  setFiles(index, obj: any) {
    this.files[index] = obj;
  }
  emptyFiles() {
    this.files = new CreditorClaim();
  }
}

export class CreditorClaim {
  particularOfDebt: any[] = [];
  particularsOfInterest: any[] = [];
  securityHeld: any[] = [];
}
export class CompanyItem {
  windingUpNumber: string;
  displayName: string;
  formId: string;
  liquidationUEN: any;
}
